import { useState } from 'react';
import { useContext } from '../context';
import useConnect from './useConnect';
import { useLastConnectorId } from './useLastConnectorId';
import { useWalletConnector } from './useWalletConnectors';

export function useWalletConnectModal() {
  const { connectAsync } = useConnect();
  const { config } = useContext();
  const walletConnector = useWalletConnector('evmWallet');
  const { updateLastConnectorId } = useLastConnectorId();

  const [error, setError] = useState<Error>();

  const openW3m = async () => {
    setError(undefined);
    if (walletConnector && walletConnector.w3mConnector) {
      const w3mcss = document.createElement('style');
      w3mcss.innerHTML = 'w3m-modal, wcm-modal{ --wcm-z-index: 2147483647; --w3m-z-index:2147483647; }';
      document.head.appendChild(w3mcss);
      try {
        let connector = walletConnector._internal.connectors.setup(walletConnector.w3mConnector);
        connector = config._internal.connectors.setup(connector);

        await connectAsync({ connector: connector });
        updateLastConnectorId('walletConnect');
      } catch (err) {
        console.log('WalletConnect openW3m', err);
        setError(err as unknown as Error);
      } finally {
        // remove modal styling
        document.head.removeChild(w3mcss);
      }
    } else {
      console.log('No WalletConnect connector available');
    }
  };

  return {
    error,
    openW3m,
  };
}
